// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"395":"BookingPanel","529":"FourOFour"}[chunkId] || chunkId) + "." + {"309":"64161f1c","395":"85654292","529":"eede95eb","537":"72d92c54","817":"42c992c0"}[chunkId] + ".css";
};